export default __webpack_public_path__ + "static/media/ing.5b68a640.svg";